import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3ecd6523")

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("i", {
    class: "Icon",
    style: {
      width: `${this.size}px`,
      height: `${this.size}px`,
      display: 'inline-block',
      backgroundImage: `url(${_ctx.CDN_PREFIX_URI}/icons/${this.type}.png)`,
      backgroundImage: `url(${_ctx.CDN_PREFIX_URI}/icons/${this.type}.svg)`,
      backgroundSize: `${this.size}px ${this.size}px`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      verticalAlign: 'middle',
    }
  }, null, 4))
})